import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { ProductSelectCategoryScreen } from "../ProductSelectCategoryScreen";
import { ProductSelectDepartmentScreen } from "../ProductSelectDepartmentScreen";
import { ProductSelectTaxGroupScreen } from "../ProductSelectTaxGroupScreen";
import { ProductSelectSupplierScreen } from "../ProductSelectSupplierScreen";
import { CreateProductRootParamList } from "../../../../types";
import { ProductFormProvider } from "../../components/ProductForm/ProductFormProvider";
import { CreateProductScreen } from "../CreateProductScreen";
import { ManageProductTagsRootScreen } from "../ManageProductTagsRootScreen";
import { ProductSelectUomScreen } from "../ProductSelectUomScreen";
import { useProductFormActionsContextProvider } from "../../components/ProductForm/hooks";
import { ProductFormActionsContext } from "../../components/ProductForm/context";
import { useSetupAllStartupEntities } from "../../../../utilities/setup";
import { ProductDescriptionLlmQuickWinRootScreen } from "../ProductDescriptionLlmScreen";
import { ProductTagsLlmQuickWinRootScreen } from "../ProductTagsLlmScreen/ProductTagsLlmQuickWinRootScreen";
import { ProductPricingLlmQuickWinRootScreen } from "../ProductPricingLlmScreen";
import { ProductSeoFriendlyNameLlmQuickWinRootScreen } from "../ProductNameSuggestionsLlmScreens/ProductSeoFriendlyNameLlmQuickWinRootScreen";

export type CreateProductRootScreenProps = StackScreenProps<
  any,
  "CreateProductRootScreen"
>;

export const CreateProductRootScreen = ({
  route,
  navigation,
}: CreateProductRootScreenProps) => {
  const Drawer = createStackHeaderNavigator<CreateProductRootParamList>();
  const { defaultValues } = route.params || { defaultFormValues: {} as any };
  const maybeParentContext = useProductFormActionsContextProvider();
  const { fetchAndSyncEntity } = useSetupAllStartupEntities();

  return (
    <ProductFormActionsContext.Provider
      value={{
        onAfterAddProduct: async (product, _) => {
          await fetchAndSyncEntity("products");
          maybeParentContext?.onAfterAddProduct &&
            (await maybeParentContext.onAfterAddProduct(product, navigation));
        },
      }}
    >
      <ProductFormProvider
        defaultFormValues={defaultValues}
        createActionContext={false}
      >
        <Drawer.Navigator
          screenOptions={{
            title: "",
            animationEnabled: true,
            headerLeft: () => <ModalCloseButton type="Cancel" />,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Drawer.Group>
            <Drawer.Screen
              name="CreateProductScreen"
              component={CreateProductScreen}
            />
            <Drawer.Screen
              name="ProductSelectCategoryScreen"
              component={ProductSelectCategoryScreen}
            />
            <Drawer.Screen
              name="ProductSelectDepartmentScreen"
              component={ProductSelectDepartmentScreen}
            />
            <Drawer.Screen
              name="ProductSelectTaxGroupScreen"
              component={ProductSelectTaxGroupScreen}
            />
            <Drawer.Screen
              name="ProductSelectSupplierScreen"
              component={ProductSelectSupplierScreen}
            />
            <Drawer.Screen
              name="ProductSelectUomScreen"
              component={ProductSelectUomScreen}
            />
          </Drawer.Group>
          <Drawer.Group
            screenOptions={{
              headerShown: false,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            }}
          >
            <Drawer.Screen
              name="ManageProductTagsRootScreen"
              component={ManageProductTagsRootScreen}
            />
            <Drawer.Screen
              name="ProductDescriptionLlmQuickWinRootScreen"
              component={ProductDescriptionLlmQuickWinRootScreen}
            />
            <Drawer.Screen
              name="ProductTagsLlmQuickWinRootScreen"
              component={ProductTagsLlmQuickWinRootScreen}
            />
            <Drawer.Screen
              name="ProductPricingLlmQuickWinRootScreen"
              component={ProductPricingLlmQuickWinRootScreen}
            />
            <Drawer.Screen
              name="ProductSeoFriendlyNameLlmQuickWinRootScreen"
              component={ProductSeoFriendlyNameLlmQuickWinRootScreen}
            />
          </Drawer.Group>
        </Drawer.Navigator>
      </ProductFormProvider>
    </ProductFormActionsContext.Provider>
  );
};
